import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18nBackend from "i18next-http-backend";

i18n
  .use(i18nBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    ns: [
      "drivers",
      "dashboard",
      "cards",
      "bulkOperation",
      "reports",
      "requests",
      "profile",
      "settings",
      "store",
      "wps",
    ],
    defaultNS: "translation",
    fallbackNS: "translation",
  });

export default i18n;
